<template>
    <v-row align="center" justify="center" class="mar-top-100">
        <v-dialog
            v-model="reviewModal"
            scrollable
            max-width="1000px"
            style="z-index: 999;"
        >
            <Deal
                :company="company"
                :currentUserId="currentUserId"
                :closeModal="closeModal"
                :baseUrl="baseUrl"
                :getAllCompaniesDeals="getAllCompaniesDeals"
            />
        </v-dialog>

        <v-col cols="10" sm="9">
            <v-row>
                <v-col cols="11" sm="11">
                    <p class="cyan--text text--darken-1 text-sm-left m-0" id="title">My Deal Flow</p>
                    <div class="m-0">List of deals in your portfolio</div>
                </v-col>
            </v-row>
            <div class="d-flex flex-column flex-md-row justify-content-between align-items-center mt-4">
                <div ref="dropdownContainer">
                    <p @click="toggleDropdown" class="m-0">
                        <span>Sort by </span>
                        <span style="cursor: pointer; font-weight: 800;">{{ typeOfFilter }}</span>
                    </p>
                    <div class="dropdownMenu d-flex justify-content-start px-2" :class="openDropdown ? 'active' : ''">
                        <ul>
                            <li @click="sortByAsc = true; sort('Recently Added')">Recently Added</li>
                            <li class="mt-2" @click="sortByAsc = 'name'; sort('Company Name')">Company Name</li>
                        </ul>
                    </div>
                </div>
                <div class="d-flex justify-content-between align-items-center" style="gap: 10px;">
                    <div class="search-input d-flex align-items-center px-2">
                        <img src="../../../assets/img/search.svg" alt="search" style="height: 22px; width: 19px;" />
                        <input class="search" type="text" v-model="searchQuery" placeholder="Search by name" />
                    </div>
                </div>
            </div>
            <hr />

            <div v-for="(dealflow, index) in companies" :key="index" class="deal-row">
                <div class="deal-item" v-if="!loader">
                    <div class="deal-logo" style="width: 60px; height: 60px;">
                        <img
                            :src="baseUrl + dealflow?.company?.logo"
                            alt=""
                            @error="handleImageError"
                        />
                    </div>
                    <div class="deal-details">
                        <div class="deal-header">
                            <p>Deal ID: {{ dealflow.id }}</p>
                            <p :style="dealflow.deal_status == 'New' ? 'color: #FF9E3A' : 'color: #00a8c3'" class="deal-status">{{ dealflow.deal_status }}</p>
                            <strong>{{ dealflow.company.company_name }}</strong>
                            <p>Raising: {{ dealflow.needs ? '$' + formatToString(dealflow.needs.raising) : '' }}</p>
                            <p>{{ dealflow.investment ? capitalizeFLetter(dealflow.investment.stage) : '' }}</p>
                            <p>HQ: {{ dealflow.company.country }}</p>
                        </div>

                        <div class="deal-subheader mt-2">
                            <p>{{ dealflow.business && dealflow.business.industry.join(', ') }}</p>
                            <p>Technology focus: {{ dealflow.business_products && dealflow.business_products.technology_focus ? 'Yes' : 'No' }}</p>
                            <p>{{ dealflow.business && dealflow.business.model }}</p>
                        </div>

                        <div class="deal-resume mt-2 ml-1">
                            <p>{{ dealflow.company_resume.resume }}</p>
                        </div>

                        <div class="deal-footer">
                            <strong>Added {{ formatDate(dealflow.created_at, userCountry == 'United States') }}</strong>
                            <div @click="setCurrentUserId(dealflow)" class="deal-action">
                                {{ dealflow.deal_status == "Interested" || dealflow.deal_status != "New" ? "Details" : "Review" }}
                            </div>
                        </div>
                    </div>
                </div>
                <hr />
            </div>

            <div class="text-center w-100" v-if="loader">
                <div class="spinner-border text-secondary" role="status">
                    <span class="sr-only">Loading...</span>
                </div>
            </div>

            <div class="text-center" v-if="companies.length === 0 && !loader">
                <img
                    alt="Ideasfundx logo"
                    src="../../../assets/img/folder.png"
                    class="mt-2"
                    height="70"
                    width="70"
                />
                <p>No deals found at the moment.</p>
            </div>
        </v-col>
    </v-row>
</template>

<script>
    import Company from '@/store/services/company/company.service.js'
    import { myMixins } from "@/mixins/mixins";
    import MainContact from '@/components/Dashboard/MainContact.vue'
    import CompanyProfile from '@/components/Dashboard/CompanyProfile.vue'
    import FounderTeam from '@/components/Dashboard/FoundingTeam.vue'
    import Product from '@/components/Dashboard/TypeOfBusiness.vue'
    import FinanceHistory from '@/components/Dashboard/FinanceHistory.vue'
    import FundingNeeds from '@/components/Dashboard/FundingNeeds.vue'
    import LegalRepresentative from '@/components/Dashboard/LegalRepresentative.vue'
    import Deal from './dealDetails/Deal.vue'
    import Profile from "@/store/services/profile-service";

    export default {
        mixins: [myMixins],
        components: {
            LegalRepresentative,
            CompanyProfile,
            FounderTeam,
            Product,
            FinanceHistory,
            FundingNeeds,
            MainContact,
            Deal
        },
        data() {
            return {
                companies: [],
                company: null,
                searchQuery: '',
                loader: false,
                baseUrl: '',
                sortByAsc: false,
                isFilterByName: true,
                openDropdown: false,
                reviewModal: false,
                current_company_id: null,
                currentUserId: null,
                typeOfFilter: '',
                add_deal_loader: false,
                dealStatus: null,
                dealStatusItems: [
                    'Interested',
                    'Deep dive',
                    'Due Diligence',
                    'Deal Negotiation',
                    'Closing',
                    'Investment',
                    'Exit'
                ],
                userCountry: null
            }
        },
        watch: {
            searchQuery() {
                if (this.searchQuery === '') {
                    this.getAllCompaniesDeals()
                }  else {
                    this.getCompaniesByName(this.searchQuery);
                }
            },
            sortByAsc() {
                this.getAllCompaniesDeals()
            }
        },
        methods: {
            toggleDropdown() {
                this.openDropdown = !this.openDropdown;
            },
            sort(type) {
                this.typeOfFilter = type;
                this.openDropdown = false;
                this.getAllCompaniesDeals();
            },
            handleOutsideClick(event) {
                if (this.$refs.dropdownContainer && !this.$refs.dropdownContainer.contains(event.target)) {
                    this.openDropdown = false;
                }
            },

            closeModal () {
                this.reviewModal = false
            },

            capitalizeFLetter (string) {
                let value = string?.replace("_", " ");
                let str = value?.toLowerCase() || null;
                return str?.replace(/^./, str[0].toUpperCase());
            },

            getCompaniesByName (newQuery) {
                this.companies = [];
                this.loader = true
                Company.getCompaniesDealsByName(newQuery).then((res) => {
                    if (res.status == 200) {
                        this.companies = res.data;
                    }
                    this.loader = false
                }).catch(() => {
                    this.loader = false;
                })
            },

            getAllCompaniesDeals () {
                this.loader = true
                this.companies = [];
                Company.getCompaniesDeals(this.sortByAsc).then((res) => {
                    if (res.status == 200) {
                        this.companies = res.data;
                    }
                    this.loader = false
                }).catch((e) => {
                    console.log("Error", e)
                    this.loader = false;
                })

                Profile.myDetails().then((res) => { this.userCountry = res.data.city })
            },

            setCurrentUserId(company) {
                this.company = company;
                this.current_company_id = null;
                this.currentUserId = company.company.user_id;
                this.current_company_id = company.company.id
                this.reviewModal = true;
            },
        },

        created() {
            this.getAllCompaniesDeals()
            this.baseUrl = window.location.protocol + '//' + window.location.host + '/storage/';
        }
    }
</script>

<style scoped>
    .search-input input {
        outline: none;
        width: 100%;
        border: none;
    }
    .search-input {
        border-radius: 4px;
        border: 1px solid var(--neutral-100, #e7eaee);
        background: var(--shades-white, #fff);
        height: 40px;
        gap: 10px;
    }
    .deals-table {
        gap: 30px;
    }
    .deals-table p {
        color: rgb(75, 75, 75);
        font-size: 15px !important;
    }
    .deals-table strong {
        font-size: 15px;
    }

    /* profile menu */
    .dropdownMenu {
        top: 65px;
        background: #f5f5f5;
        box-shadow: 0px 20px 24px -4px rgba(16, 24, 40, 0.08);
        border-radius: 4px;
        max-height: 0;
        overflow: hidden;
        transition: max-height 0.5s ease-in-out, transform 0.5s ease-in-out;
        z-index: 999;
        transform: scaleY(0);
        transform-origin: top;
    }
    .dropdownMenu.active {
        max-height: 413px;
        transform: scaleY(1);
    }

    .dropdownMenu ul {
        list-style: none;
        padding: 0;
        margin: 0;
    }

    .dropdownMenu li {
        margin: 0;
        cursor: pointer;
    }

    .dropdownMenu li:hover {
        color: #5ae6ff !important;
    }



    @media (max-width: 768px) {
        .company-details {
            flex: 1;
        }
        img {
            width: 50px;
            height: 50px;
        }
    }

    @media (max-width: 576px) {
        img {
            width: 40px;
            height: 40px;
        }
        .first-follow-up-block p,
        .second-follow-up-block p {
            font-size: 14px;
        }
        .btn-deal-action {
            font-size: 14px;
            padding: 5px 10px;
        }
    }


    /* Deal */
    .deal-row {
        display: flex;
        flex-direction: column;
        padding: 10px;
        border-radius: 10px;
        margin-bottom: 16px;
    }

    .deal-item {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        align-items: flex-start;
    }

    .deal-logo img {
        width: 60px;
        height: 60px;
        object-fit: cover;
    }

    .deal-details {
        flex-grow: 1;
        margin-left: 20px;
    }

    .deal-header, .deal-subheader, .deal-footer {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
    }

    .deal-header p, .deal-subheader p, .deal-footer p, .deal-footer strong {
        margin: 0 5px;
        flex-basis: calc(33.333% - 10px); /* Adjusted for responsive columns */
    }

    .deal-action {
        padding: 8px 16px;
        border: 1px solid #00a8c3;
        border-radius: 20px;
        color: #00a8c3;
        font-size: 17px;
        cursor: pointer;
        text-align: center;
        white-space: nowrap;
    }

    hr {
        margin-top: 20px;
        border: 0;
        border-top: 1px solid #e0e0e0;
    }

    /* Media Queries for Responsiveness */
    @media (max-width: 768px) {
        .deal-header p, .deal-subheader p, .deal-footer p {
            flex-basis: 100%; /* Stack items on smaller screens */
            margin: 5px 0;
        }

        .deal-logo img {
            width: 50px;
            height: 50px;
        }

        .deal-action {
            width: 100%;
            margin-top: 10px;
        }
    }
</style>